import { Component, ChangeDetectionStrategy } from '@angular/core';
import { RouterLink } from '@angular/router';
import { SparrowIconEnum } from '../../core/icons-registry';

@Component({
  selector: 'sparrow-unauthorized',
  templateUrl: './unauthorized.component.html',
  styleUrls: ['./unauthorized.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [RouterLink],
})
export class UnauthorizedComponent {
  readonly SparrowIcon = SparrowIconEnum;
}
